import * as React from 'react';

export function Professionalize() {
  return (
    <section className="ong-pro">
      <style>{`
        .ong-pro {
          padding: 72px 24px;
          background: #fafaf7;
        }
        .ong-pro-inner {
          max-width: 960px;
          margin: 0 auto;
        }
        .ong-pro h2 {
          font-size: 28px;
          font-weight: 800;
          color: #1a1a1a;
          margin: 0 0 8px;
          text-align: center;
        }
        .ong-pro .subtitle {
          font-size: 16px;
          color: #666;
          text-align: center;
          margin: 0 0 40px;
        }
        .ong-pro-cards {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 24px;
        }
        .ong-pro-card {
          display: flex;
          align-items: flex-start;
          gap: 14px;
          background: #fff;
          border-radius: 12px;
          padding: 18px 20px;
          border: 1px solid #eee;
        }
        .ong-pro-card .card-icon {
          width: 40px;
          height: 40px;
          border-radius: 10px;
          background: #f0fdf0;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }
        .ong-pro-card .card-icon i {
          font-size: 18px;
          color: #1EAA25;
        }
        .ong-pro-card-text h3 {
          font-size: 15px;
          font-weight: 700;
          color: #1a1a1a;
          margin: 0 0 4px;
        }
        .ong-pro-card-text p {
          font-size: 14px;
          color: #666;
          line-height: 1.5;
          margin: 0;
        }
        .ong-pro .closing {
          text-align: center;
          font-size: 16px;
          color: #333;
          font-weight: 600;
          margin: 36px 0 0;
        }
        @media (max-width: 768px) {
          .ong-pro-cards {
            grid-template-columns: 1fr;
            gap: 16px;
          }
          .ong-pro h2 {
            font-size: 24px;
          }
        }
      `}</style>
      <div className="ong-pro-inner">
        <h2>Ordená el abastecimiento de tu organización</h2>
        <p className="subtitle">Menos tiempo gestionando proveedores, más tiempo en lo que importa.</p>

        <div className="ong-pro-cards">
          <div className="ong-pro-card">
            <div className="card-icon"><i className="fa fa-file-invoice" /></div>
            <div className="ong-pro-card-text">
              <h3>Facturación formal</h3>
              <p>Facturas A o B para rendiciones a donantes, organismos y auditorías.</p>
            </div>
          </div>
          <div className="ong-pro-card">
            <div className="card-icon"><i className="fa fa-calendar-check" /></div>
            <div className="ong-pro-card-text">
              <h3>Entrega programada</h3>
              <p>El comedor no puede esperar. Elegí día y horario, llega siempre.</p>
            </div>
          </div>
          <div className="ong-pro-card">
            <div className="card-icon"><i className="fa fa-chart-simple" /></div>
            <div className="ong-pro-card-text">
              <h3>Control y trazabilidad</h3>
              <p>Historial completo de compras para auditorías, reportes y rendiciones.</p>
            </div>
          </div>
        </div>

        <p className="closing">Una organización que rinde cuentas necesita un proveedor que rinda cuentas.</p>
      </div>
    </section>
  );
}
